var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"zwx-fastreport"},[_c('zwx-ipc',{ref:"wsRptRef",on:{"message":_vm.wsRpt,"connect":_vm.connect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }